import React from 'react';
import {
  BoxCenter,
  GridContainer,
  GridItem4,
  GridItem8,
  LBox,
  TitlePink,
} from '../../../components/Common/common';
import InputLabel from '@mui/material/InputLabel';
import Stack from '@mui/material/Stack';
import SelectImage from '../../../components/Form/SelectImage';
import { Box } from '@mui/material';
import SelectInput from '../../../components/Form/SelectInput';
import QuickAddButton from '../../../components/Button/QuickAddButton';

const PointForm = ({
  handleOpenModal,
  modalOptions,
  pointRuleOptions,
  bannerOptions,
  editData,
}) => {
  return (
    <LBox mt={5}>
      <TitlePink>任意付与・日次初回起動ポイント詳細設定</TitlePink>
      <Stack mt={4} p={4} rowGap={{ md: 2, xs: 5 }}>
        {/* banner_id */}
        <GridContainer>
          <GridItem4 flexCenter={true}>
            <InputLabel htmlFor={'banner_id'}>使用バナー</InputLabel>
          </GridItem4>
          <GridItem8>
            <SelectImage
              name={'banner_id'}
              labelName={''}
              showLabel={false}
              options={bannerOptions}
              defaultValue={editData.banners_id}
              numOfAddForm={2}
              handleOpenModal={handleOpenModal}
            />
          </GridItem8>
        </GridContainer>
        {/* modal */}
        <GridContainer>
          <GridItem4 flexCenter={true}>
            <InputLabel htmlFor={'modal_id'}>使用モーダル</InputLabel>
          </GridItem4>
          <GridItem8>
            <SelectImage
              name={'modal_id'}
              labelName={''}
              showLabel={false}
              options={modalOptions}
              defaultValue={editData.modals_id}
              numOfAddForm={3}
              handleOpenModal={handleOpenModal}
            />
          </GridItem8>
        </GridContainer>
        {/* point */}
        <GridContainer>
          <GridItem4 flexCenter={true}>
            <InputLabel htmlFor={'point_rule_id'}>
              使用ポイントルール
            </InputLabel>
          </GridItem4>
          <GridItem8>
            <Stack flexDirection={'row'} alignItems={'center'} columnGap={10}>
              <Box width={'40%'} overflow={'hidden'}>
                <SelectInput
                  name={'point_rule_id'}
                  labelName={''}
                  showLabel={false}
                  defaultValue={editData.point_rules_id}
                  options={pointRuleOptions}
                />
              </Box>
              <Box>
                <QuickAddButton onClick={() => handleOpenModal(4)} />
              </Box>
              <Box width={'30%'}>&nbsp;</Box>
            </Stack>
          </GridItem8>
        </GridContainer>
      </Stack>
    </LBox>
  );
};

export default PointForm;
